import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiClock } from "react-icons/fi";
import { ticketLink } from "pages/UserQueries/useLinkedTicket";
import { PendingQuery } from "pages/UserQueries/MyQueries.api";

/* Shown instead of the raise-query form while the member's last query is still waiting for support. */
export function PendingQueryNotice({ pending }: { pending: PendingQuery }) {
  const reference = `${pending.source.toUpperCase()}-${pending.id}`;
  return (
    <section className="zs-card" role="status">
      <div className="flex flex-col items-center gap-3 px-5 py-10 text-center sm:px-10">
        <span className="flex items-center justify-center w-12 h-12 rounded-full bg-warning-soft text-warning">
          <FiClock size={22} aria-hidden="true" />
        </span>
        <h2 className="text-lg font-semibold font-display text-ink">Please wait for our reply</h2>
        <p className="max-w-md text-sm leading-relaxed text-ink-3">
          Your query <span className="font-mono font-semibold text-ink-2">{reference}</span> is waiting for our support team.
          We’ll email you as soon as we reply. You can send a new query once we’ve picked this one up.
        </p>
        <Link className="mt-2 zs-btn zs-btn-primary" to={ticketLink(false, pending.source, pending.id)}>
          View your query <FiArrowRight aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}
